module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/transform.js
 ** module id = 815
 ** module chunks = 0
 **/